<template>
    <tr>
        <td>{{ entry.date }}</td>
        <status-icon-cell :data="data" :value="entry.status" />
        <td>{{ username }}</td>
        <comment-cell :comment="entry.comment" :username="username" />
    </tr>
</template>

<script>
import StatusIconCell from '../cells/StatusIconCell.vue';
import CommentCell from '../cells/CommentCell.vue';

export default {
    components: { StatusIconCell, CommentCell },
    props: {
        data: Object,
        entry: Object,
    },
    computed: {
        username() {
            return this.entry.user ? this.entry.user.full_name : 'System';
        },
    },
};
</script>
